import { useMsal } from '@azure/msal-react';
import { enableTestAuth, msalInstance } from '../auth/msal';
import { loginRequest } from '../config/authConfig';

// Coffee Run Login Button Component - Original Implementation
interface LoginButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export const LoginButton: React.FC<LoginButtonProps> = ({
  className = '',
  children = 'Sign in',
}) => {
  const { instance, accounts } = useMsal();

  const handleLogin = () => {
    console.log('Login button clicked');
    console.log('Current accounts:', accounts);

    if (enableTestAuth) {
      console.log('[MSAL][TEST] Bypassing real login - using mock account');
      const mock = (msalInstance as any).getAllAccounts()[0];
      msalInstance.setActiveAccount(mock);
      // Trigger a re-render for components relying on MSAL React hooks
      window.dispatchEvent(new Event('storage'));
      return;
    }

    // Try popup first since redirect is having cross-origin issues
    instance.loginPopup(loginRequest).catch(e => {
      console.error('Popup login failed:', e);

      // Fallback to redirect if popup fails
      console.log('Attempting redirect login as fallback');
      instance.loginRedirect(loginRequest).catch(redirectError => {
        console.error('Redirect login also failed:', redirectError);
      });
    });
  };

  return (
    <button
      onClick={handleLogin}
      className={`btn-primary ${className}`}
      type="button"
    >
      {children}
    </button>
  );
};

export default LoginButton;
